/**
 * Search-result meta of the public pages in Russian (ADR-0062): the /ru/… pages. The English source is PUBLIC_PAGES in
 * app/publicRoutes.ts; title ≤ 60 characters, description ≤ 155 (publicRoutes.test.ts). A legal page's title is the
 * document's own title (ru/legal-docs) with the brand.
 */
export default {
  "/": {
    title: "Funded Lime — проп-челленджи: крипто, FX и фьючерсы",
    description: "Пройдите торговый челлендж на симулированном счёте по реальным рыночным данным и получите финансирование. Крипто, FX и фьючерсы CME, выплаты до 90%.",
    ogTitle: "Funded Lime — Выжми весь рынок",
    ogDescription: "Проп-челленджи на крипто, FX и фьючерсах по реальным рыночным данным. Открытые правила, у каждого исполнения — объяснение, выплаты до 90%.",
  },
  "/programs": {
    title: "Проп-челленджи и цены · Funded Lime",
    description: "Соберите челлендж: крипто-перпетуалы, FX/CFD или фьючерсы CME; Instant, 1 этап, 2 этапа или спринт. Все правила и цены видны до покупки.",
  },
  "/faq": {
    title: "Вопросы и ответы о проп-трейдинге · Funded Lime",
    description: "Реальные ли это деньги, как исполняются ордера, когда кончается торговый день, могут ли измениться правила, что если пропадут данные и как идут выплаты.",
  },
  "/legal/terms": {
    title: "Условия использования · Funded Lime",
    description: "Договор между вами и Funded Lime: что мы продаём, как устроены проверка и funded-аккаунты, что запрещено и что будет, если что-то пойдёт не так.",
  },
  "/legal/refunds": {
    title: "Политика платежей и возвратов · Funded Lime",
    description: "Как оплатить программу Funded Lime в криптовалюте, что происходит, если с платежом что-то не так, и когда плата возвращается.",
  },
  "/legal/payouts": {
    title: "Политика выплат · Funded Lime",
    description: "Когда funded-аккаунт получает выплату, сколько, куда она уходит и почему запрос на выплату могут отклонить.",
  },
  "/legal/prohibited": {
    title: "Запрещённые торговые практики · Funded Lime",
    description: "Торговля, которая использует симуляцию или правила вместо умения торговать и запрещена на счетах Funded Lime.",
  },
  "/legal/aml": {
    title: "Политика AML и KYC · Funded Lime",
    description: "Как Funded Lime защищает платформу от отмывания денег, финансирования терроризма, обхода санкций и мошенничества.",
  },
  "/legal/privacy": {
    title: "Политика конфиденциальности · Funded Lime",
    description: "Какие персональные данные собирает Funded Lime, зачем, кто ещё их видит, сколько мы их храним и что вы можете от нас потребовать.",
  },
  "/legal/cookies": {
    title: "Политика cookie · Funded Lime",
    description: "Какие cookie и хранилище браузера использует Funded Lime, для чего и как вы выбираете.",
  },
  "/legal/risk": {
    title: "Раскрытие рисков · Funded Lime",
    description: "Прочтите до покупки: все счета Funded Lime симулированные. Что означают симулированные результаты и чего они не означают.",
  },
  "/legal/execution": {
    title: "Политика исполнения · Funded Lime",
    description: "Как движок Funded Lime исполняет ордера на симулированных счетах по реальным рыночным данным: задержка, проход по стакану, спред, комиссии.",
  },
};
